import { render } from "./AudioPlaybackBlockedNotice.vue.js?vue&type=template&id=618e1a77!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AudioPlaybackBlockedNotice.vue?vue&type=template&id=618e1a77"
import script from "./AudioPlaybackBlockedNotice.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AudioPlaybackBlockedNotice.vue?vue&type=script&lang=js"
export * from "./AudioPlaybackBlockedNotice.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AudioPlaybackBlockedNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/AudioPlaybackBlockedNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "618e1a77"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('618e1a77', __exports__)) {
    api.reload('618e1a77', __exports__)
  }
  
  module.hot.accept("./AudioPlaybackBlockedNotice.vue.js?vue&type=template&id=618e1a77!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AudioPlaybackBlockedNotice.vue?vue&type=template&id=618e1a77", () => {
    api.rerender('618e1a77', render)
  })

}


export default __exports__